import React, { Suspense } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import AppLoader from 'screens/appLoader'
import ThemePrivate from 'screens/themePrivate'
import { validateUrl } from 'utils'

export default function Routes({ user }) {
  const { roles } = user
  const routes = [
    { url: `/admin`, userType: `Admin` },
    { url: `/intersystem`, userType: `Admin` },
    { url: `/proveedor`, userType: `Provider` },
    { url: `/usuario`, userType: `Validator` },
    { url: `/recovery`, userType: `Recovery` },
    { url: `/validadornacional`, userType: `ValidatorNacional` },
  ].filter(({ userType }) => roles.includes(userType))
  return (
    <Suspense fallback={<AppLoader />}>
      <Switch>
        {routes.map(({ url, userType }) => {
          return (
            <Route
              path={url}
              render={() => <ThemePrivate userType={userType} />}
              key={`route-${userType}`}
            />
          )
        })}
        <Route
          path="/not-found"
          exact={true}
          key={`route-notFound`}
          render={() => window.open(`https://www.sernatur.cl/404`)}
        />
        <Redirect to={validateUrl(roles)} />
      </Switch>
    </Suspense>
  )
}
